import Component from '../../../../../ui-components/Component';
import Styles from './styles';
import { withResizer, withTranslations } from '../../../../../HoCs';
import React from 'react';
import view from '../../../../../Enums'
import stageMap from './../../config';

class CommercialDetails extends Component {
    
    styles = Styles;
    translation_key = 'properties_translations';
    
    render() {
        return (
            <>
                <div style={this.gs('instruction_box')}>
                    <div style={this.gs('instruction_left')}>{this.gc('this_step_includes')}</div>
                    <div style={this.gs('instruction_right')}>
                        <div style={this.gs('content_parent')}>
                        <ol style={this.gs('ol')}>
                            <li style={this.gs('instruction_title')}>{this.gc('finding_suitable_oyo')}</li>
                            <li style={this.gs('instruction_title')}>{this.gc('commercial_discussion')}</li>
                        </ol>
                        </div>
                    </div>
                </div>
    
                <div style={this.gs('instruction_box')}>
                    <div style={this.gs('instruction_left')}>Instructions</div>
                    <div style={this.gs('instruction_right')}>
                        <div style={this.gs('content_parent')}>
                        <div style={this.gs('instruction_title')}>{this.gc('oyo_business_representative_commercial')}</div>
                        </div>
                    </div>
                </div>
                
                <div style={{...this.gs('instruction_box'),...(this.getViewMode() == view.MOBILE ?{borderBottom:''}:{})}}>
                    <div style={this.gs('instruction_left')}>{this.gc('trivia_for_you')}</div>
                    <div style={this.gs('instruction_right')}>
                        <div style={this.gs('content_parent')}>
                        <ol style={this.gs('ol')}>
                            {this.gc('oyo_is_providing') && <li style={this.gs('instruction_title')}>{this.gc('oyo_is_providing')}</li>}
                            {this.gc('property_owners_with') && <li style={this.gs('instruction_title')}>{this.gc('property_owners_with')}</li>}
                        </ol>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withResizer(withTranslations(CommercialDetails));